<template>
  <div>
    <!-- Pickup Agent slider -->
    <div class="mb-5">
      <pickup-agent-slider
          @update-pickup-agent="getPickupAgent"
          ref="pickup_agent_slider"
      />
    </div>


    <v-row class="mb-6">
      <v-col cols="6" md="6">
        <v-text-field
            v-model="shipment_search_query"
            :placeholder="$lang.ACCEPT_SHIPMENT_SEARCH"
            outlined
            rounded
            dense
            @keyup="getShipmentList(true)"
            append-icon="mdi-magnify"
            hide-details
            single-line
        ></v-text-field>
      </v-col>
      <v-col cols="6" md="6" class="text-right">
        <v-btn
            color="primary"
            rounded
            outlined
            width="100"
            :disabled="selected.length == 0 ? true : false"
            @click="dropShipment(null)"
            :loading="btn_loading"
            class="border-w-2"
        >
          <b>{{ $lang.DROP }}</b>
        </v-btn>
        <v-btn
            color="primary"
            width="100"
            outlined
            rounded
            :disabled="selected.length == 0 ? true : false"
            @click="OpenReassignAfentDialog"
            class="ml-2 border-w-2"
        >
          <b>{{ $lang.RE_ASSIGN }}</b>
        </v-btn>
        <v-btn
            color="primary"
            width="100"
            text
            @click="refreshTable"
            class="ml-2"
        >
          <v-icon>mdi-autorenew</v-icon>
          <b>{{ $lang.REFRESH }}</b>
        </v-btn>
      </v-col>
    </v-row>

    <!-- shipment List -->
    <div>
      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="shipment_list"
          :single-select="singleSelect"
          item-key="shipment_id"
          show-select
          :hide-default-footer="true"
          :disable-sort="true"
          :items-per-page="$keys.PAGE_LENGTH"
          class="elevation-1 custome-header-bg custome-table-body"
          :loading="table_loading"
      >
        <template v-slot:item.picked_up_at="{ item }">
          <p>{{ item.pickup_time }}</p>
          <p>{{ item.pickup_date }}</p>
        </template>

        <template v-slot:item.retailer_firm_name="{ item }">
          <p>{{ item.retailer_firm_name }}</p>
          <p v-if="item.retailer_mobile_number">
            {{ $lang.MOBILE_PREFIX }}{{ item.retailer_mobile_number }}
          </p>
          <p>({{ item.retailer_location }})</p>
        </template>

        <template v-slot:item.pickup_agent_name="{ item }">
          <p>{{ item.pickup_agent_name }}</p>
          <p v-if="item.pickup_agent_mobile_number">
            {{ $lang.MOBILE_PREFIX }}{{ item.pickup_agent_mobile_number }}
          </p>
        </template>
        <template v-slot:item.shipment_status="{ item }">
    <span :class="getClassSatus(item.shipment_status)">{{
        item.shipment_status
      }}</span>
        </template>
        <template v-slot:item.wholesaler="{ item }">
          <p>{{ item.wholesaler_firm_name }}</p>
          <p>{{ $lang.MOBILE_PREFIX }}{{ item.wholesaler_mobile_number }}</p>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
              color="primary"
              rounded
              outlined
              width="100"
              :disabled="item.shipment_status != $keys.PICKED_UP ? true : false"
              @click="dropShipment(item.shipment_id)"
              class="border-w-2"
          >
            <b>{{ $lang.DROP }}</b>
          </v-btn>
        </template>

        <!--empty state  -->
        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_SHIPMENTS"/>
        </template>
      </v-data-table>

      <!-- pagination  -->
      <v-pagination
          class="custome-pagination"
          v-model="page_number"
          :total-visible="7"
          :length="total_page_count"
          @input="getShipmentList(true)"
      ></v-pagination>

      <!--  daloag components -->
      <reassign-agent
          :agent_type="$keys.PICKUP_AGENT"
          :dialog="re_assigne_dialog"
          :shipment_id_list="shipment_id_list"
          :reAssign="reAssignPickupAgent"
      />
    </div>
  </div>
</template>
<script>
export default {
  components: {
    PickupAgentSlider: () => import("./child/PickupAgentSlider.vue"),
    ReassignAgent: () =>
        import("@/components/common-components/ReassignAgent.vue"),
  },
  data() {
    return {
      page_number: 1,
      total_page_count: 0,
      singleSelect: false,
      shipment_list: [],
      shipment_id_list: [],
      selected: [],
      table_loading: false,
      btn_loading: false,
      pickup_agent: null,

      shipment_search_query: "",
      headers: [
        {text: 'Shipment ID', align: 'start', value: 'shipment_id'},
        {text: 'Pickup Time', align: 'start', value: 'picked_up_at'},
        {text: "Pickup Agent", value: "pickup_agent_name"},
        {text: "Wholesaler Info", value: "wholesaler"},
        {text: "Challan", value: "challan_number"},
        {text: "Status", value: "shipment_status", align: "center"},
        {text: "Retailer Info", value: "retailer_firm_name"},
        {text: "", value: "action"},
      ],
      /* for the reassigne pickup agent */
      re_assigne_dialog: {
        flag: false,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy();
    next()
  },
  created() {
    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init(this.dropShipment);
    console.log(this.$barcodeScanner.hasListener())
    this.$store.dispatch("drawer/setActiveTab", -1);
  },

  methods: {
    /* update the data  pickupagent */
    getPickupAgent(agent) {
      if (this.pickup_agent != agent) {
        this.table_loading = true;
        this.selected = [];
      }
      this.pickup_agent = agent;
      this.getShipmentList(false);
    },
    refreshTable() {
      this.table_loading = true;
      this.getShipmentList(false);
    },
    /* fetch the agent shipment list */
    getShipmentList(is_cancel=false) {
      const self = this;
      let status_list = [self.$keys.PICKED_UP, self.$keys.CONFIRMED];
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.shipment_search_query,
      };
      if (this.pickup_agent != "All")
        params.pickup_agent_id = this.pickup_agent.id;

      const successHandler = (response) => {
        if (response.data.success) {
          this.shipment_list = response.data.shipment_list;
          this.total_page_count = response.data.total_page_count;
        }
      };
      const finallyHandler = () => {
        this.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };
      self.request_GET(
          self,
          self.$urls.DROP_SHIPMENT_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler,
          is_cancel
      );
    },

    /* Drop Shipment API call*/
    dropShipment(shipment_id = null) {
      console.log("Drop shipment function")
      const self = this;
      let shipment_id_list = [];
      let is_error = false;

      if (shipment_id) {
        if (!shipment_id.includes("MEDX"))
          return false
      }
      //  validate id shipment is not picked up
      if (!shipment_id) {
        console.log("else");
        for (let i = 0; i < this.selected.length; i++) {
          if (this.selected[i].shipment_status == this.$keys.PICKED_UP)
            shipment_id_list.push(this.selected[i].shipment_id);
          else is_error = true;
        }
      }

      if (is_error) {
        this.showSnakeBar(
            "warning",
            "One of the selected shipment is not picked up"
        );
        return false;
      }

      self.btn_loading = true;
      var form = new FormData();
      if (shipment_id)
        form.append("shipment_id", shipment_id);
      else
        form.append("shipment_id_list", JSON.stringify(shipment_id_list));

      const successHandler = (response) => {
        if (response.data.success) {
          self.resetBarcode();
          this.$store.dispatch("snackbar/setSnackbar", {
            flag: true,
            text: "Shipments dropped at warehouse",
            color: "success",
          });
        }
      };
      const finallyHandler = () => {
        self.btn_loading = false;
      };

      this.request_POST(
          self,
          self.$urls.DROP_SHIPMENT,
          form,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },

    /* OPen  reaasignment deialog*/
    OpenReassignAfentDialog() {
      let shipment_id_list = [];
      let is_error = false;
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i].shipment_status == this.$keys.CONFIRMED)
          shipment_id_list.push(this.selected[i].shipment_id);
        else is_error = true;
      }

      if (is_error) {
        this.showSnakeBar(
            "warning",
            "One of the selected shipment is picked up"
        );
        return false;
      }
      this.shipment_id_list = shipment_id_list;
      this.re_assigne_dialog.flag = true;
    },

    /*re- assing pickup agent and change shipment status*/
    reAssignPickupAgent(agent_id) {
      const self = this;
      var form = new FormData();
      form.append("shipment_id_list", JSON.stringify(self.shipment_id_list));
      form.append("pickup_agent_id", agent_id);

      const successHandler = (response) => {
        if (response.data.success) {
          self.re_assigne_dialog.flag = false;
          self.getShipmentList();
          self.getPickupAgents();
        }
      };
      const finallyHandler = () => {
      };
      this.request_POST(
          self,
          self.$urls.CHANGE_SHIPMENT_STATUS,
          form,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },

    // Reset to the last barcode before hitting enter (whatever anything in the input box)
    resetBarcode() {
      let barcode = this.$barcodeScanner.getPreviousCode();
      // do something...
    },
  },
};
</script>